"use strict";

import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/es5/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#62c4b3",
        secondary: "#ffffff",
        accent: "#262626",
        anchor: "#62c4b3"
      }
    }
  },
  lang: {
    locales: { pt },
    current: "pt"
  }
});
